import { LastPage } from "@mui/icons-material";
import { useInfiniteQuery } from "@tanstack/react-query";
import config from "configs/config";
import apiClient from "lib/api-client";

const fetchCollectionsDesign = async ({ pageParam = 1, queryKey }) => {
  try {
    const [
      ,
      {
        collectionName,
        categoryName,
        limit,
        searchTerm,
        sortBy,
        order,
        labourFilter,
        classFilter,
        diamondPieces,
        diamondWeight,
        goldGrossWeight,
        goldNetWeight,
        ratioRange,
        designInCollection,
        designInSets,
        bestSeller,
        highestSeller,
        stockStatus,
        designCreateDate,
        isHidden
      },
    ] = queryKey;

    const payload1 = {
      collectionName,
      categoryName,
      pageNumber: pageParam,
      limit,
      searchTerm,
      sortBy,
      order,
      labourFilter: labourFilter.length > 0 ? labourFilter : "",
      classFilter: classFilter.length > 0 ? classFilter : "",
      diamondPieces: diamondPieces.length > 0 ? diamondPieces : "",
      diamondWeight: diamondWeight.length > 0 ? diamondWeight : "",
      goldGrossWeight: goldGrossWeight.length > 0 ? goldGrossWeight : "",
      goldNetWeight: goldNetWeight.length > 0 ? goldNetWeight : "",
      ratioRange: ratioRange.length > 0 ? ratioRange : "",
      designInCollection: designInCollection.length > 0 ? designInCollection : "",
      designInSets: designInSets.length > 0 ? designInSets : "",
      bestSeller: bestSeller ? bestSeller : "",
      highestSeller: highestSeller?.length > 0 ? highestSeller : "",
      stockStatus: stockStatus?.length > 0 ? stockStatus : "",
      designCreateDate,
       isHidden,
    };

    const response = await apiClient.post(`${config.baseUrl}/api/v1/collection/getDesignsInCollection`, payload1);

    if (response.status !== 200) {
      throw new Error("Error fetching categories");
    }
    return {
      data: response.data.designs,
      nextPage: response.data.pagination.pageNumber + 1,
      totalPages: response.data.pagination.totalPages,
      totalCount: response.data.pagination.totalDesigns,
      collectionId: response.data.collectionId,
    };
  } catch (error) {
    console.log("errorrrrrrrrrrrrrrrr", error);
    return error.response.data;
  }
};

export const useCollectionDesigns = ({
  categoryName = "",
  limit = 10,
  collectionName = "",
  searchTerm = "",
  sortBy = "",
  order = "asc",
  labourFilter = "",
  classFilter = "",
  diamondPieces = "",
  diamondWeight = "",
  goldGrossWeight = "",
  goldNetWeight = "",
  ratioRange = "",
  designInCollection = "",
  designInSets = "",
  bestSeller = "",
  highestSeller = "",
  stockStatus = "",
  designCreateDate = [],
   isHidden = true,
}) => {
  return useInfiniteQuery({
    queryKey: [
      "collectiondesigns",

      {
        collectionName,
        categoryName,
        limit,
        searchTerm,
        sortBy,
        order,
        labourFilter,
        classFilter,
        diamondPieces,
        diamondWeight,
        goldGrossWeight,
        goldNetWeight,
        ratioRange,
        designInCollection,
        designInSets,
        bestSeller,
        highestSeller,
        stockStatus,
        designCreateDate,
         isHidden,
      },
    ],

    queryFn: ({ pageParam = 1 }) =>
      fetchCollectionsDesign({
        pageParam,
        queryKey: [
          "collectiondesigns",

          {
            collectionName,
            categoryName,
            limit,
            searchTerm,
            sortBy,
            order,
            labourFilter,
            classFilter,
            diamondPieces,
            diamondWeight,
            goldGrossWeight,
            goldNetWeight,
            ratioRange,
            designInCollection,
            designInSets,
            bestSeller,
            highestSeller,
            stockStatus,
            designCreateDate,
             isHidden,
          },
        ],
      }),

    getNextPageParam: (lastPage) => {
      if (lastPage.nextPage <= lastPage.totalPages) {
        return lastPage.nextPage;
      }
      return undefined;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
